import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <img 
              src="https://static.readdy.ai/image/2ab997fe47dead7cf7b8ff123e32b869/ba0dbd0d92393323e150edd9e4f1c7a7.jpeg" 
              alt="Mirókids" 
              className="h-12 mb-4"
            />
            <p className="text-gray-400 leading-relaxed">
              专为儿童设计的隐形矫治方案，让每个孩子都拥有自信微笑
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">快速链接</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/product" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  产品介绍
                </Link>
              </li>
              <li>
                <Link to="/cases" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  成功案例
                </Link>
              </li>
              <li>
                <Link to="/find-doctor" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  寻找医生
                </Link>
              </li>
              <li>
                <Link to="/for-doctors" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  医生合作
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4">联系我们</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>400-123-4567</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>info@mirokids.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span>上海市徐汇区钦州北路1122弄</span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="text-lg font-bold mb-4">关注我们</h3>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-douban-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
          <p className="text-gray-400">
            © 2024 Mirókids. All rights reserved.
          </p>
          <p className="text-gray-400">沪ICP备2026009814号-1</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
